import { useState, useEffect } from 'react';
import { searchFacets, SearchFacets } from '../api/search-api';

export function useSearchFacets(moduleId: string | undefined, term: string) {
  const [facets, setFacets] = useState<SearchFacets | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!moduleId || !term.trim()) {
      setFacets(null);
      setIsLoading(false);
      return;
    }

    const fetchFacets = async () => {
      setIsLoading(true);
      try {
        const data = await searchFacets(moduleId, term.trim());
        setFacets(data);
      } catch {
        setFacets(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchFacets();
  }, [moduleId, term]);

  return { facets, isLoading };
}
